export const selectMessage = state => state.messages.message;
